module.exports = __webpack_public_path__ + "media/images/icons/outlined/pound-75edbb075e753b9e91e83eb03e940b3c.svg";